var map = {
	"./10_BL.mp3": "3268",
	"./10_Long.mp3": "74ea",
	"./11_BL.mp3": "8442",
	"./11_Long.mp3": "d88c",
	"./12_BL.mp3": "1e36",
	"./12_Long.mp3": "411e",
	"./13_BL.mp3": "0fc6",
	"./13_Long.mp3": "19d9",
	"./14_BL.mp3": "d1a8",
	"./14_Long.mp3": "aab3",
	"./15_BL.mp3": "5b73",
	"./15_Long.mp3": "71ee",
	"./16_BL.mp3": "16c1",
	"./16_Long.mp3": "153a",
	"./17_BL.mp3": "96fd",
	"./17_Long.mp3": "63e2",
	"./18_BL.mp3": "7024",
	"./18_Long.mp3": "e625",
	"./19_BL.mp3": "1786",
	"./19_Long.mp3": "c30b",
	"./1_BL.mp3": "496e",
	"./1_Long.mp3": "7667",
	"./20_BL.mp3": "a69e",
	"./20_Long.mp3": "7a44",
	"./21_BL.mp3": "e89f",
	"./21_Long.mp3": "2172",
	"./22_BL.mp3": "7b68",
	"./22_Long.mp3": "0d1f",
	"./23_BL.mp3": "bdbc",
	"./23_Long.mp3": "3153",
	"./24_BL.mp3": "0543",
	"./24_Long.mp3": "4f6f",
	"./25_BL.mp3": "01c0",
	"./25_Long.mp3": "7d31",
	"./26_BL.mp3": "2a16",
	"./26_Long.mp3": "9e4f",
	"./27_BL.mp3": "638c",
	"./27_Long.mp3": "e479",
	"./28_BL.mp3": "c31a",
	"./28_Long.mp3": "6fd4",
	"./29_BL.mp3": "3bc1",
	"./29_Long.mp3": "c621",
	"./2_BL.mp3": "b011",
	"./2_Long.mp3": "0cf5",
	"./30_BL.mp3": "dbe5",
	"./30_Long.mp3": "a188",
	"./31_BL.mp3": "1b4d",
	"./31_Long.mp3": "5506",
	"./32_BL.mp3": "b254",
	"./32_Long.mp3": "3157",
	"./33_BL.mp3": "123d",
	"./33_Long.mp3": "15f7",
	"./34_BL.mp3": "b4ed",
	"./34_Long.mp3": "4d19",
	"./35_BL.mp3": "f4b2",
	"./35_Long.mp3": "9131",
	"./36_BL.mp3": "832e",
	"./36_Long.mp3": "10e8",
	"./37_Long.mp3": "e16b",
	"./38_BL.mp3": "b8b8",
	"./38_Long.mp3": "6087",
	"./39_BL.mp3": "dd4b",
	"./39_Long.mp3": "bad1",
	"./3_BL.mp3": "2d80",
	"./3_Long.mp3": "62ae",
	"./40_BL.mp3": "4e65",
	"./40_Long.mp3": "2bde",
	"./41_BL.mp3": "cb2c",
	"./41_Long.mp3": "9995",
	"./42_BL.mp3": "225b",
	"./42_Long.mp3": "323c",
	"./43_Long.mp3": "43a6",
	"./44_BL.mp3": "df30",
	"./44_Long.mp3": "971f",
	"./45_BL.mp3": "2b7d",
	"./45_Long.mp3": "f23c",
	"./46_BL.mp3": "aa9e",
	"./46_Long.mp3": "4e9f",
	"./47_BL.mp3": "6d3f",
	"./47_Long.mp3": "6c5e",
	"./48_BL.mp3": "f1ff",
	"./48_Long.mp3": "5056",
	"./49_Long.mp3": "4d2d",
	"./4_BL.mp3": "7331",
	"./4_Long.mp3": "4c04",
	"./50_BL.mp3": "0703",
	"./50_Long.mp3": "da05",
	"./51_BL.mp3": "b5fb",
	"./51_Long.mp3": "fd98",
	"./52_BL.mp3": "c567",
	"./52_Long.mp3": "a21c",
	"./53_BL.mp3": "2427",
	"./53_Long.mp3": "f000",
	"./54_BL.mp3": "669a",
	"./54_Long.mp3": "9886",
	"./55_BL.mp3": "f0d5",
	"./55_Long.mp3": "fa30",
	"./56_Long.mp3": "4554",
	"./57_BL.mp3": "caf6",
	"./57_Long.mp3": "0329",
	"./58_BL.mp3": "5284",
	"./58_Long.mp3": "58e5",
	"./59_Long.mp3": "319d",
	"./5_BL.mp3": "65b7",
	"./5_Long.mp3": "e3a0",
	"./60_BL.mp3": "bca1",
	"./60_Long.mp3": "b289",
	"./61_BL.mp3": "399d",
	"./61_Long.mp3": "a50c",
	"./62_BL.mp3": "7302",
	"./62_Long.mp3": "b0e6",
	"./63_BL.mp3": "5745",
	"./63_Long.mp3": "556e",
	"./64_BL.mp3": "3389",
	"./64_Long.mp3": "d3e4",
	"./65_BL.mp3": "6859",
	"./65_Long.mp3": "375b",
	"./66_BL.mp3": "b03c",
	"./66_Long.mp3": "6c9b",
	"./67_BL.mp3": "ef77",
	"./67_Long.mp3": "91f6",
	"./68_BL.mp3": "ead3",
	"./68_Long.mp3": "ff32",
	"./69_BL.mp3": "1832",
	"./69_Long.mp3": "6c66",
	"./6_BL.mp3": "4ead",
	"./6_Long.mp3": "dfb7",
	"./70_BL.mp3": "0335",
	"./70_Long.mp3": "4e3a",
	"./71_BL.mp3": "d7ca",
	"./71_Long.mp3": "9cbe",
	"./72_BL.mp3": "c384",
	"./72_Long.mp3": "817d",
	"./73_BL.mp3": "1083",
	"./73_Long.mp3": "7bab",
	"./74_BL.mp3": "3c46",
	"./74_Long.mp3": "98ea",
	"./75_BL.mp3": "9385",
	"./75_Long.mp3": "77fe",
	"./76_BL.mp3": "8813",
	"./76_Long.mp3": "ba27",
	"./77_BL.mp3": "e514",
	"./77_Long.mp3": "1e33",
	"./78_BL.mp3": "98d5",
	"./78_Long.mp3": "1841",
	"./79_BL.mp3": "7150",
	"./79_Long.mp3": "b303",
	"./7_BL.mp3": "8355",
	"./7_Long.mp3": "bc42",
	"./80_Long.mp3": "29da",
	"./81_BL.mp3": "81e3",
	"./81_Long.mp3": "ff9e",
	"./82_BL.mp3": "17c1",
	"./82_Long.mp3": "53d2",
	"./83_BL.mp3": "1c2a",
	"./83_Long.mp3": "2fed",
	"./84_BL.mp3": "65ec",
	"./84_Long.mp3": "817d4",
	"./85_BL.mp3": "8116",
	"./85_Long.mp3": "bf85",
	"./86_BL.mp3": "534c",
	"./86_Long.mp3": "0914",
	"./87_BL.mp3": "3dfa",
	"./87_Long.mp3": "8586",
	"./88_BL.mp3": "684f",
	"./88_Long.mp3": "3ee3",
	"./89_BL.mp3": "7536",
	"./89_Long.mp3": "af2b8",
	"./8_BL.mp3": "ff6f",
	"./8_Long.mp3": "e91a",
	"./90_BL.mp3": "5f38",
	"./90_Long.mp3": "bb59",
	"./9_BL.mp3": "7a65",
	"./9_Long.mp3": "9114",
	"./first_number_out_1.mp3": "efef",
	"./first_number_out_2.mp3": "7f6d",
	"./first_number_out_3.mp3": "6be9",
	"./game_end_1.mp3": "6d15",
	"./game_end_2.mp3": "ddd2",
	"./game_end_3.mp3": "516f",
	"./game_end_4.mp3": "23c5",
	"./game_end_5.mp3": "c97e",
	"./jackpot_winner.mp3": "c726",
	"./jackpot_winner_2.mp3": "88e4",
	"./jackpot_winner_3.mp3": "0c9d",
	"./jackpot_winner_4.mp3": "4b89",
	"./next_game_start_1.mp3": "26bc",
	"./next_game_start_2.mp3": "ba0f",
	"./next_game_start_3.mp3": "daf1",
	"./next_game_start_4.mp3": "7cac",
	"./next_game_start_5.mp3": "3155",
	"./next_number_out_1.mp3": "a85c",
	"./next_number_out_2.mp3": "b170",
	"./next_number_out_3.mp3": "ca42",
	"./next_number_out_4.mp3": "9603",
	"./next_number_out_5.mp3": "6f89",
	"./playing_full_house_1.mp3": "ea71",
	"./playing_full_house_2.mp3": "7064",
	"./playing_full_house_3.mp3": "50c3",
	"./playing_full_house_4.mp3": "72bf",
	"./playing_full_house_5.mp3": "0b75",
	"./playing_full_house_6.mp3": "2577",
	"./playing_single_line_1.mp3": "a9ba",
	"./playing_single_line_2.mp3": "aa91",
	"./playing_single_line_3.mp3": "f5f6",
	"./playing_single_line_4.mp3": "f24e",
	"./playing_single_line_5.mp3": "0ffe",
	"./playing_single_line_6.mp3": "2f2c",
	"./playing_two_line_1.mp3": "9c8e",
	"./playing_two_line_2.mp3": "978f",
	"./playing_two_line_3.mp3": "dab4",
	"./playing_two_line_4.mp3": "7a5c",
	"./playing_two_line_5.mp3": "2233",
	"./thankyou_message_1.mp3": "78e8",
	"./thankyou_message_2.mp3": "ad9a",
	"./thankyou_message_3.mp3": "2c98",
	"./thankyou_message_4.mp3": "13f3",
	"./thankyou_message_5.mp3": "9a52",
	"./thankyou_message_6.mp3": "c571",
	"./welcome_1.mp3": "63a8",
	"./welcome_2.mp3": "2ecb",
	"./welcome_3.mp3": "d634",
	"./winner_double_line_1.mp3": "7099",
	"./winner_double_line_2.mp3": "0251",
	"./winner_double_line_3.mp3": "7e99",
	"./winner_double_line_4.mp3": "428c",
	"./winner_double_line_5.mp3": "89ae",
	"./winner_full_house_1.mp3": "2a83",
	"./winner_full_house_2.mp3": "2c14",
	"./winner_full_house_3.mp3": "10d1",
	"./winner_full_house_4.mp3": "96f9",
	"./winner_full_house_5.mp3": "8e5e",
	"./winner_full_house_6.mp3": "0d23",
	"./winner_single_line_1.mp3": "66f3",
	"./winner_single_line_2.mp3": "ed8d",
	"./winner_single_line_3.mp3": "7651",
	"./winner_single_line_4.mp3": "0830"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fa7";